/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import { Link } from "react-router-dom";
import { getOverlap,getIsMinuteZero,extractToFromTimes } from "../utils/getIsOverlap";
import moment from "moment";
import { baseUrl } from "../constants/url";
import { api } from "../constants/api";

const SlotPriceTable = () => {

  //for getting Table data
  const rows: {
    id: number;
    amount: number;
    cgst: number;
    sgst: number;
    startTime: string;
    endTime: string;
  }[] = [];

  //initial values for post Data
  const initialPostValue={ id: 0, amount: 0, cgst: 2.50, sgst: 2.50, startTime: "", endTime: "" }

  const [tableData, setTableData] = useState(rows);
  const [postData, setPostData] = useState(initialPostValue);
  const [isUpdateFlag, setIsUpdateFlag] = useState(false);
  const [slotDate, setSlotDate] = useState("");
  const [slotDateFlag, setSlotDateFlag] = useState(false);

  // useEffect(() => {
  //   if (localStorage.getItem('lastAuthTimeMillis') &&
  //   // @ts-ignore
  //   parseInt(localStorage.getItem('lastAuthTimeMillis')) > (new Date().getTime()) - 30*60*1000) {
  //      // @ts-ignore
  //     axios.defaults.headers.common['MemberCode'] = localStorage.getItem('MemberCode');
  //      // @ts-ignore
  //     axios.defaults.headers.common['MemberId'] = localStorage.getItem('MemberId');
  //      // @ts-ignore
  //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('Authorization');
  //   } else {
  //     window.location.href = '/';
  //   }
  // }, []);

  const getSlotPriceTable = async () => {
    const res = await api(true, `/admin/slotsPrice?date=${slotDate}`, 'get')
    //  axios(`${baseUrl}/slotsPrice?date=${slotDate}`);
    const data = res.data.slotePrice.sort( (a: any, b: any) => +new Date(a.startTime) - +new Date(b.startTime) );
    setTableData(data);
  };


  useEffect(() => {
    slotDateFlag && getSlotPriceTable();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slotDateFlag,slotDate]);


  const handleChangeHandler = (e: any) => {
    setPostData((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let num = 0;
    tableData.map((data) => {
      if (data.id !== postData.id) {
        return (num = num + getOverlap(extractToFromTimes(postData), extractToFromTimes(data)));
      }
    });
    if (num === 0) {
      //For Posting Data
      if (!isUpdateFlag) {
        try {
          const toTime=postData.startTime;
          const fromTime=postData.endTime;
          const isMinuteZero=getIsMinuteZero({fromTime,toTime});
          if(isMinuteZero){
            await api(true, `/admin/newSlotPrice`, 'post', {
              ...postData,
              startTime: new Date(postData.startTime).toISOString(),
              endTime: new Date(postData.endTime).toISOString(),
            })
            //  axios.post(`${baseUrl}/newSlotPrice`, {
            //   ...postData,
            //   startTime: new Date(postData.startTime).toISOString(),
            //   endTime: new Date(postData.endTime).toISOString(),
            // });
            getSlotPriceTable();
          }else{
            window.alert("Please Add Time In Hours");
          }
          setPostData(initialPostValue);
        } catch (error) {
          console.log(error);
        }
      } else {
      //for Updating Data
        try {
          const toTime=postData.startTime;
          const fromTime=postData.endTime;
          const isMinuteZero=getIsMinuteZero({fromTime,toTime});
          if(isMinuteZero){
          await api(true, `/admin/slotPrice/${postData.id}`, 'put', {
            amount: postData.amount,
            cgst: postData.cgst,
            sgst: postData.sgst,
            startTime: new Date(postData.startTime).toISOString(),
            endTime: new Date(postData.endTime).toISOString(),
          })
          //  axios.put(`${baseUrl}/slotPrice/${postData.id}`, {
          //   amount: postData.amount,
          //   startTime: new Date(postData.startTime).toISOString(),
          //   endTime: new Date(postData.endTime).toISOString(),
          // });
          getSlotPriceTable();
        }else{
          window.alert("Please Add Time In Hours");
        }
        setIsUpdateFlag(false);
        setPostData(initialPostValue);
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      window.alert("Please Add Unoverlaped Start and End Time");
    }
  };


  const handleDelete = async (item: any) => {
    try {
      await api(true, `/admin/slotPrice/${item.id}`, 'delete')
      // axios.delete(`${baseUrl}/slotPrice/${item.id}`);
      let array = tableData;
      array = array.filter((itemObj: any) => itemObj.id !== item.id);
      setTableData(array);
    } catch (error) {
      console.log(error);
    }
  };


  const handleUpdate = (data: any) => {
    const stTime = moment(data.startTime, 'YYYY-MM-DD HH:mm:ss')
    const endTime = moment(data.endTime, 'YYYY-MM-DD HH:mm:ss')
    
    if(endTime.isAfter(stTime.clone().endOf('day').add(1, 'second'))){
      data.endTime = moment(data.endTime).subtract(1, 'second').format("YYYY-MM-DD HH:mm:ss");
    }else {
      data.endTime= moment(data.endTime).format("YYYY-MM-DD HH:mm:ss")
    }
    data.startTime= moment(data.startTime).format("YYYY-MM-DD HH:mm:ss")
    setPostData(data);
    setIsUpdateFlag(true);
  };

  const handleSubmitDate=()=>{
      if(slotDate===""){
        window.alert("Please Add Date")
      }else{
        setSlotDateFlag(true)
      }
  }

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">Slot Price</h2>
      <div className="sloteDate">
        <h2>Slot Date:</h2>
        <div className="time-row">
        <input
          type="date"
          value={ slotDate }
          name="slotDate"
          onChange={(e) => setSlotDate(e.target.value)}
        />
        </div>
        <button onClick={() =>handleSubmitDate()}>Slots</button>
      </div>
      {slotDateFlag ? (
        <>
          <form className="form-slotPrice form-basePrice" onSubmit={ handleSubmit }>
            <div>
              <label>START TIME</label>
              <input
                type="datetime-local"
                value={postData.startTime}
                name="startTime"
                onChange={(e) => handleChangeHandler(e)}
              />
            </div>
            <div>
              <label>END TIME</label>
              <input
                type="datetime-local"
                value={postData.endTime}
                name="endTime"
                onChange={(e) => handleChangeHandler(e)}
              />
            </div>
            <div>
              <label>Amount</label>
              <input
                type="number"
                value={postData.amount}
                name="amount"
                onChange={(e) => handleChangeHandler(e)}
              />
            </div>
            <div>
              <label>CGST</label>
              <input
                type="number"
                value={postData.cgst}
                name="cgst"
                onChange={(e) => handleChangeHandler(e)}
              />
            </div>
            <div>
              <label>SGST</label>
              <input
                type="number"
                value={postData.sgst}
                name="sgst"
                onChange={(e) => handleChangeHandler(e)}
              />
            </div>
            <div>
              <button className="submitbtn" type="submit" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{isUpdateFlag ? "SAVE" : "SUBMIT"}</button>
            </div>
          </form>
          <div>
            <div className="table-responsive">
            <table className="tbl styled-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th style={{ minWidth: 200 }}>START TIME</th>
                  <th style={{ minWidth: 200 }}>END TIME</th>
                  <th>AMOUNT</th>
                  <th>CGST</th>
                  <th>SGST</th>
                  <th style={{ minWidth: 250 }}>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((data, i) => {
                    return (
                      <tr key={i} style={{ height: 60 }}>
                        <td>{i + 1}</td>
                        <td>{new Date(data.startTime).toLocaleString()}</td>
                        <td>{new Date(data.endTime).toLocaleString()}</td>
                        <td>{data.amount}</td>
                        <td>{data.cgst}</td>
                        <td>{data.sgst}</td>
                        <td style={{ display: "flex", gap: 20, alignItems: "center", justifyContent: "center", alignSelf: "center", alignContent: "center", marginTop: 8 }}>
                          <button className="btn updt" onClick={() => handleUpdate(data)}>UPDATE</button>
                          <button className="btn dngr" onClick={() => {
                            if (window.confirm("Are you sure you want to delete this slot price?")) {
                              handleDelete(data);
                            }
                          }}>DELETE</button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="loader" style={{ height: 60 }}>No Slots Available On this Day</td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>
          </div>
        </>
      ) : (
        <h2 className="loader2">Please Search SLots By Date</h2>
      )}

      <Link to="/admin/basePrice" className="slot">Base Price</Link>
    </div>
  );
};

export default SlotPriceTable;
